/**
 * Identifies how a slider-options value change was produced, so consumers can treat the two
 * interaction modes differently (e.g. a group control that scales relatively while the user drags
 * the handle, but sets an absolute value when a number is typed into the input).
 */
export enum SliderChangeSource {
  SLIDER = 'slider',
  INPUT = 'input',
}
